import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IncentivioDotsProps {
  /** Overrides the dots fill (e.g. white on a dark/gradient surface). */
  color?: string;
}

const IncentivioDots = ({ color }: IncentivioDotsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const fill = color ?? theme.palette.common.blue2;

  return (
    <svg
      viewBox="0 0 84 84"
      aria-label={t('IncentivioLogo.alt', { incentivio: 'Incentivio' })}
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          fill={fill}
          d="M84.8,20.39c0,11.05-9.36,20.44-20.38,20.44-10.92,0-20.46-9.56-20.42-20.48C44.04,9.31,53.43-.03,64.48,0c11.14.03,20.33,9.25,20.33,20.39ZM64.4,8.92c-6.31,0-11.43,5.07-11.51,11.38-.07,6.3,5.49,11.76,11.85,11.63,6.24-.13,11.22-5.38,11.13-11.72-.09-6.44-5.02-11.29-11.47-11.29Z"
        />
        <path
          fill={fill}
          d="M40.73,78.08c-9.63-.02-17.45-7.7-17.64-17.32-.19-9.59,8.05-17.83,17.77-17.77,9.57.06,17.52,7.9,17.65,17.41.13,9.67-7.95,17.71-17.78,17.69ZM49.64,60.56c-.09-4.85-4.24-8.79-9.12-8.65-4.65.13-8.6,4.13-8.58,8.68.02,4.75,4.23,8.71,9.12,8.6,4.63-.11,8.66-4.16,8.58-8.63Z"
        />
        <path
          fill={fill}
          d="M17.68,5.52c9.49-.05,17.47,7.83,17.59,17.37.13,9.66-7.94,17.88-17.6,17.94C8.19,40.88-.13,32.44,0,22.9.14,13.51,8.21,5.57,17.68,5.52ZM17.49,31.94c4.78.13,9-3.94,9.07-8.74.07-4.38-3.99-8.7-8.43-8.97-4.68-.29-9.09,3.79-9.26,8.55-.18,4.78,3.83,9.03,8.62,9.16Z"
        />
      </g>
    </svg>
  );
};
export default IncentivioDots;
